import { render, staticRenderFns } from "./label-list.vue?vue&type=template&id=5ff2a6d0&scoped=true&"
import script from "./label-list.vue?vue&type=script&lang=js&"
export * from "./label-list.vue?vue&type=script&lang=js&"
import style0 from "./label-list.vue?vue&type=style&index=0&id=5ff2a6d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff2a6d0",
  null
  
)

export default component.exports